module.exports = __webpack_public_path__ + "static/img/7-2.7d4ce41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/7-2.png
// module id = tHLa
// module chunks = 25